import styled, { css } from 'styled-components';
import { CROSS_SELL_VERTICAL_BREAKPOINT } from '../../../../utils/cross-sell';

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 1.5rem 1rem 1.5rem;
  & > .hefesto-title h1 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: 0;
  }
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  .hefesto-step-by-step__content {
    margin: 0;
  }
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;

  button:nth-child(2) {
    width: 48px;
    display: flex;
    justify-content: center;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  .subtitle {
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  min-width: 0;
  overflow-x: hidden;
`;

interface PageWrapperProps {
  showVerticalCrossSell?: boolean;
}

const HEADER_HEIGHT = '8rem';

export const PageWrapper = styled.div<PageWrapperProps>`
  ${({ showVerticalCrossSell }) =>
    showVerticalCrossSell &&
    css`
      display: grid;
      grid-template-columns: 1fr 20rem;
      grid-template-rows: 1fr;
      height: calc(100vh - ${HEADER_HEIGHT});
    `}
`;

export const ContentToggle = styled.button<{ fullWidth?: boolean }>`
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue6};
  gap: 0.5rem;

  cursor: pointer;

  margin-left: 1.5rem;
  height: 48px;
  ${({ fullWidth }) => !fullWidth && `width: 48px;`}
`;

export const ResumeHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OrderDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
`;

export const CrossSellSection = styled.div<{ marginTop?: boolean }>`
  padding: 0 1.5rem 1.5rem;
  ${({ marginTop }) => marginTop && `margin-top: 1rem;`}
`;

export const CrossSellSidebar = styled.aside`
  overflow-y: auto;
  min-height: 0;
  background: ${({ theme }) => theme.colors.white};
  min-width: 20rem;

  @media (max-width: ${CROSS_SELL_VERTICAL_BREAKPOINT - 1}px) {
    display: none;
  }
`;
